// GORED merchandise products
export const products = [
  {
    id: 'hanging-skeleton-red',
    name: 'Hanging Skeleton T-Shirt RED',
    price: 24.99,
    description: 'Official GORED merchandise. Heavy cotton black t-shirt with brutal red artwork.',
    images: [
      'https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/0fwa9l5x_redprev.png',
      'https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/o4pjo4cv_redprev2.png'
    ],
    color: 'red',
    available: true
  },
  {
    id: 'hanging-skeleton-white',
    name: 'Hanging Skeleton T-Shirt WHITE',
    price: 24.99,
    description: 'Official GORED merchandise. Heavy cotton black t-shirt with brutal white artwork.',
    images: [
      'https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/a961yhbn_WHITEPREVIEW.png',
      'https://customer-assets.emergentagent.com/job_gored-merch-drop/artifacts/i2ths3ec_WHITEPREVIEW2.png'
    ],
    color: 'white',
    available: true
  }
];

// General merch config
export const merchConfig = {
  currency: 'USD',
  availableSizes: ['S', 'M', 'L', 'XL', '2XL'],
  serviceFee: 3.99,
  shippingCost: 6.99,
  pickupLocation: 'Woodstock, GA 30066',
  contactEmail: 'gored.offc@gmail.com',
  sizingChart: {
    width: { S: 18, M: 20, L: 22, XL: 24, '2XL': 26 },
    length: { S: 28, M: 29, L: 30, XL: 31, '2XL': 32 },
    sleeve: { S: 15.10, M: 16.50, L: 18.00, XL: 19.50, '2XL': 21.00 }
  }
};

// Helper to get product by ID
export const getProductById = (id) => products.find(p => p.id === id);

// Legacy exports for backward compatibility
export const shirtName = products[0].name;
export const price = products[0].price;

export const mockOrders = [];

export const addMockOrder = (orderData) => {
  const order = {
    id: `ORDER-${Date.now()}`,
    ...orderData,
    createdAt: new Date().toISOString(),
    status: 'pending'
  };
  mockOrders.push(order);
  return order;
};
